import { flattenObject } from 'es-toolkit'
import { isHexColor } from '@dashboard/ui'
import { Theme } from 'src/layouts/token-studio'

/**
 * This function is used to get the value of a token.
 * @param theme
 * @param path
 * @returns
 */
export const getTokenValue = (theme: Theme, path: string): string | null => {
  const key = path.replace('{', '').replace('}', '')
  const keyWithSpace = key.includes('color.') ? `color.${key}` : `theme.${key}`
  const flattenedTheme = flattenObject(theme)

  const value = flattenedTheme[`${keyWithSpace}.value`]
  const extensions = flattenedTheme[`${keyWithSpace}.$extensions.studio.tokens.modify.type`]

  if (extensions) {
    return null
  }

  if (!extensions && isHexColor(value)) {
    return value
  }

  if (value) {
    return getTokenValue(theme, value)
  }

  return null
}
